import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const cropApi = createApi({
  reducerPath: "cropApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/is/crop",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Crop"],
  endpoints: (build) => ({
    // Get a single crop by ID
    getCrop: build.query({
      query: (id) => `/${id}`,
      providesTags: ["Crop"],
    }),

    // Get all crops for a specific asset
    getCropsByAsset: build.query({
      query: (assetId) => `/asset/${assetId}`,
      providesTags: ["Crop"],
    }),

    // Create a new crop
    addCrop: build.mutation({
      query({ assetId, cropData }) {
        return {
          url: `/asset/${assetId}`,
          method: "POST",
          body: cropData,
        };
      },
      invalidatesTags: ["Crop"],
    }),

    // Batch create crops
    addCropsBatch: build.mutation({
      query(body) {
        console.log("Batch payload:", body);
        return {
          url: "/batch",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Crop"],
    }),

    // Update a crop
    updateCrop: build.mutation({
      query({ id, ...body }) {
        return {
          url: `/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Crop"],
    }),

    // Batch update crops
    updateCropsBatch: build.mutation({
      query(body) {
        return {
          url: "/batch",
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Crop"],
    }),

    // Delete a crop
    deleteCrop: build.mutation({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Crop"],
    }),

    getCropByExternalIds: build.query({
      query: ({ external_asset_id, external_crop_id, asset_id }) => ({
        url: "/by-external-ids",
        method: "GET",
        params: {
          external_asset_id,
          external_crop_id,
          asset_id,
        },
      }),
      providesTags: ["Crop"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetCropQuery,
  useGetCropsByAssetQuery,
  useAddCropMutation,
  useAddCropsBatchMutation,
  useUpdateCropMutation,
  useUpdateCropsBatchMutation,
  useDeleteCropMutation,
  useGetCropsByIdsQuery,
} = cropApi;
